// src/components/Promos/WhyPrayPopup.jsx
import React from "react";

export default function WhyPrayPopup({
  open,
  onClose,

  // ✅ Contenu pilotable (remoteConfig)
  title = "",
  body = "", // string (optionnel)

  // ✅ Bouton CTA (remoteConfig)
  ctaLabel = "",
  onCta = null,

  // ✅ Accessibilité / libellés
  closeLabel = "Fermer",

  // ✅ Fallback si tu veux injecter du JSX custom
  children = null,
}) {
  if (!open) return null;

  const hasTitle = typeof title === "string" && title.trim().length > 0;
  const hasBody = typeof body === "string" && body.trim().length > 0;
  const hasCta = typeof ctaLabel === "string" && ctaLabel.trim().length > 0 && typeof onCta === "function";

  return (
    <div className="promo-modal-overlay" role="dialog" aria-modal="true">
      <div className="promo-modal">
        {/* ✅ Bande bleue réelle (impossible à cacher) */}
        <div className="promo-top-strip" aria-hidden="true" />

        <div className="promo-modal-header">
          {/* ✅ Titre optionnel */}
          {hasTitle ? <h2 className="promo-modal-title">{title}</h2> : <div />}

          <button
            type="button"
            className="promo-modal-close"
            onClick={onClose}
            aria-label={closeLabel}
            title={closeLabel}
          >
            ✕
          </button>
        </div>

        <div className="promo-modal-body">
          {/* ✅ Priorité au body string, sinon children */}
          {hasBody ? <p style={{ margin: 0, whiteSpace: "pre-line" }}>{body}</p> : children}

          {/* ✅ CTA optionnel */}
          {hasCta && (
            <div style={{ marginTop: "14px" }}>
              <button type="button" className="promo-cta-btn" onClick={onCta}>
                {ctaLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
